import { DefaultTheme } from "styled-components";

export const PrimaryTheme: DefaultTheme = {
    colors: {
        introBackground: "#231942",
        blogBackground: "#BFD8BD",
        sideBar: "#5E548E",
        introCard: "#f7e1d7",
        black: "#000000",
        button: "#77BFA3",
        techsBackground: "#ABC4FF",
        aboutMeBackground: "#F4E285",
        pink: "#FF98F5",
        boxShadow: "#9F86C0",
        phrase: "#000000",
    },
};
